/*
  eci: offers from promotion records. Removes every element whose data-eci-starts is still ahead or whose
  data-eci-ends has passed (snippets/eci-offer-attrs.liquid), because Shopify can serve a page from cache after an
  offer ends. Liquid already filters by the same times (snippets/eci-offer-live.liquid); this is the second layer.

  Loaded with defer before theme.js (layout/theme.liquid), so slides are gone before the slideshow starts. Content
  added later to the product lists, recommendations and quick buy (filters, quick view) is checked as it arrives.
*/
(function () {
  var SELECTOR = '[data-eci-starts], [data-eci-ends]';

  // "+0100" becomes "+01:00": older Safari only parses the offset with a colon
  function parseTime(value) {
    if (!value) return NaN;
    return Date.parse(value.replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
  }

  function isOutside(el, now) {
    var starts = parseTime(el.getAttribute('data-eci-starts'));
    var ends = parseTime(el.getAttribute('data-eci-ends'));
    return (!isNaN(starts) && now < starts) || (!isNaN(ends) && now >= ends);
  }

  // A slide also takes its page dot with it; when the shown slide goes, the next one is shown instead
  function removeSlide(slide) {
    var slideshow = slide.closest('slide-show');
    var wasShown = !slide.hasAttribute('hidden');

    if (!slideshow) {
      slide.remove();
      return;
    }

    var dot = slide.id ? slideshow.querySelector('[aria-controls="' + slide.id + '"]') : null;
    if (dot) dot.remove();
    slide.remove();

    var slides = slideshow.querySelectorAll('slide-show-item');

    if (slides.length === 0) {
      var section = slideshow.closest('.shopify-section');
      if (section) section.hidden = true;
      return;
    }

    if (wasShown) {
      slides[0].removeAttribute('hidden');
      var firstDot = slideshow.querySelector('[aria-controls="' + slides[0].id + '"]');
      if (firstDot) firstDot.setAttribute('aria-current', 'true');
    }

    if (slides.length < 2) {
      var dots = slideshow.querySelector('page-dots');
      if (dots) dots.remove();
    }
  }

  // The Special Offers grid shows its empty text once every card in it has gone
  function updateOfferGrids(root) {
    var grids = root.querySelectorAll('[data-eci-offers-grid]');

    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.querySelector('.eci-offers__item')) return;

      var section = grid.closest('.eci-offers');
      var empty = section ? section.querySelector('[data-eci-offers-empty]') : null;
      grid.hidden = true;
      if (empty) empty.hidden = false;
    });
  }

  function check(root) {
    var now = Date.now();
    var removed = 0;
    var elements = Array.prototype.slice.call(root.querySelectorAll(SELECTOR));

    if (root.matches && root.matches(SELECTOR)) elements.unshift(root);

    elements.forEach(function (el) {
      if (!el.isConnected || !isOutside(el, now)) return;

      if (el.tagName === 'SLIDE-SHOW-ITEM') {
        removeSlide(el);
      } else {
        el.remove();
      }
      removed += 1;
    });

    if (removed > 0) updateOfferGrids(document);
    keepLabels(root);
  }

  // Focal rewrites the product page label list on every variant change (ProductMeta._updateLabels), which would drop
  // the offer labels (snippets/product-info.liquid). Each list's offer labels are kept here and put back after it.
  var labelLists = [];

  function keepLabels(root) {
    var lists = Array.prototype.slice.call(root.querySelectorAll('[data-product-label-list]'));
    if (root.matches && root.matches('[data-product-label-list]')) lists.unshift(root);

    lists.forEach(function (list) {
      var labels = Array.prototype.slice.call(list.querySelectorAll('.label--eci-offer'));
      if (labels.length === 0) return;
      labelLists = labelLists.filter(function (kept) { return kept.list !== list && kept.list.isConnected; });
      labelLists.push({ list: list, labels: labels });
    });
  }

  function restoreLabels() {
    var now = Date.now();
    labelLists.forEach(function (kept) {
      kept.labels = kept.labels.filter(function (label) { return !isOutside(label, now); });
      kept.labels.forEach(function (label) {
        if (label.parentNode !== kept.list) kept.list.appendChild(label);
      });
    });
  }

  check(document);

  // A page restored from the back and forward cache is not reloaded, so check it again
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) check(document);
  });

  // An entry that names variants shows on the product page only while one of them is selected
  // (snippets/eci-offer-item.liquid prints the lists); Focal fires variant:changed on every change
  function hasId(list, id) {
    return (',' + (list || '') + ',').indexOf(',' + id + ',') > -1;
  }

  // Listening on the document runs after Focal's own listener on the product form, so the list is already rewritten
  document.addEventListener('variant:changed', function (event) {
    restoreLabels();
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    document.querySelectorAll('[data-eci-variants]').forEach(function (el) {
      if (!hasId(el.getAttribute('data-eci-product-variants'), variant.id)) return;
      if (hasId(el.getAttribute('data-eci-variants'), variant.id)) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  });

  // Only the containers Focal fills after load: filtered and paged product lists, recommendations, and quick buy
  var CONTAINERS = 'product-facet, product-list, product-recommendations, recently-viewed-products, ' +
    'cart-drawer-recommendations, quick-buy-drawer, quick-buy-popover';

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) check(node);
        });
      });
    });

    document.querySelectorAll(CONTAINERS).forEach(function (container) {
      // A container inside another one is already covered by the outer one's subtree
      if (container.parentElement && container.parentElement.closest(CONTAINERS)) return;
      observer.observe(container, { childList: true, subtree: true });
    });
  }
})();
